const Pages = {
  '/': 'dreamstation-landing',
  '/questionnaire': 'dreamstation-survey',
  '/qualify': 'dreamstation-share',
  '/bonus': 'dreamstation-prize',
  '/terms': 'dreamstation-terms'
};

const CLIENT = "promotion page";
const PROMO = "2017 Frame.io Dreamstation for Adobe Creative Cloud";

export default {
  hasRecordedSignupStart: false,
  hasRecordedTermsAcceptance: false,
  hasRecordedSignupSubmit: false,

  didStartSignup(position) {
    if (!this.hasRecordedSignupStart) {
      this.hasRecordedSignupStart = true;
      this.track(`dreamstation-signup-started`, { position });
    }
  },

  didAcceptTerms(position) {
    if (!this.hasRecordedTermsAcceptance) {
      this.hasRecordedTermsAcceptance = true;
      this.track(`dreamstation-accept-terms`, { position });
    }
  },

  didClickLearnMore(title) {
    this.track(`dreamstation-learn-more-clicked`, { title, page: Pages['/'] });
  },

  // Survey Stuff
  didCompletePanel({ id, responses }, q) {
    let responseMapping;
    let validResponses = responses.filter(r => !!r[1]);
    switch(q.type) {
      case 'all':
        responseMapping = {};
        responses.forEach(res => {
          responseMapping[q.items[res[0]].title.toLowerCase().split(' ').join('_')] = res[1];
        });
        break;
      case 'some':
         if (validResponses.length) {
           responseMapping = responses.filter(r => !!r[1]).map(r => {
             let val = q.items[r[0]].title;
             if (val === "Other") {
               return `Other: ${r[1]}`;
             } else {
               return val;
             }
           });
         }
        break;
      case 'discrete':
        if (validResponses.length) {
          let val = q.items[validResponses[0][0]].title;
          if (val === "Other") {
            responseMapping = `Other: ${validResponses[0][1]}`;
          } else {
            responseMapping = q.items[validResponses[0][0]].title;
          }
        }
        break;
    }

    switch(id) {
      case "1":
        this.identify(responseMapping);
        this.track(`dreamstation-survey-name-submitted`, responseMapping);
        break;
      case "2":
        this.track(`dreamstation-survey-create-video-submitted`, { dreamstation_survey_answer_create_video: responseMapping });
        break;
      case "3-2b":
      case "8":
        this.track(`dreamstation-survey-annual-videos-submitted`, { dreamstation_survey_answer_annual_videos: responseMapping });
        break;
      case "4-2b":
        this.track(`dreamstation-survey-primary-software-submitted`, { dreamstation_survey_answer_primary_software: responseMapping });
        break;
      case "3-2d":
        this.track(`dreamstation-survey-company-submitted`, { dreamstation_survey_answer_company: responseMapping['company_name'] });
        break;
      case "4-2d":
        this.track(`dreamstation-survey-job-title-submitted`, { dreamstation_survey_answer_job_title: responseMapping['job_title'] });
        break;
      case "3":
        this.track(`dreamstation-survey-organization-type-submitted`, { dreamstation_survey_answer_organization_type: responseMapping });
        break;
      case "4":
        this.track(`dreamstation-survey-company-video-types-submitted`, { dreamstation_survey_answer_video_types: responseMapping });
        break;
      case "5":
        this.track(`dreamstation-survey-company-video-area-submitted`, { dreamstation_survey_answer_video_area: responseMapping });
        break;
      case "6-5a":
      case "6-5b":
      case "6-5c":
      case "6-5d":
        this.track(`dreamstation-survey-company-video-role-submitted`, { dreamstation_survey_answer_video_role: responseMapping });
        break;
      case "7":
        this.track(`dreamstation-survey-video-team-size-submitted`, { dreamstation_survey_answer_video_team_size: responseMapping });
        break;
      case "9":
        this.track(`dreamstation-survey-primary-software-submitted`, { dreamstation_survey_answer_primary_software: responseMapping });
        break;
    }
  },

  didSubmitSurvey() {
    this.track(`dreamstation-survey-submitted-client`);
  },

  // Qualify Stuff
  didClickSocialShare(platform) {
    this.track(`dreamstation-${platform}-share-clicked`);
  },

  // Bonus Stuff
  didClickStartFrameTrial() {
    this.track(`dreamstation-start-frameio-trial-clicked`);
  },

  didClickFramePlugin() {
    this.track(`dreamstation-download-frameio-adobe-plugin-clicked`);
  },

  didClickCCTrial() {
    this.track(`dreamstation-start-adobe-trial-clicked`);
  },

  // Internals
  didSendReduxAction(action) {
    switch(action.type) {
      case "SUBMIT_EMAIL_FULFILLED":
        const identifyOpts = { Intercom: { user_hash: action.payload.intercom_user_hash } };
        this.identify({ email: action.meta.emailAddress }, identifyOpts);

        if (!this.hasRecordedSignupSubmit) {
          this.hasRecordedSignupSubmit = true;
          this.track(`dreamstation-signed-up-client`, {
            email: action.meta.emailAddress,
            position: action.meta.position,
            adobe_redemption_code: action.payload.code
          });
        }

        break;
      case "@@router/LOCATION_CHANGE":
        this.track(`page-viewed-${Pages[action.payload.pathname]}`);
        this.page(action.payload.pathname);
        break;
    }
  },

  // Segment Interface
  identify(traits, opts) {
    console.log('SEGMENT: identify', traits, opts);
    window.analytics.identify(traits, opts);
  },

  track(name, properties = {}) {
    console.log('SEGMENT: track', name, { client: CLIENT, promotion: PROMO, ...properties });
    window.analytics.track(name, { client: CLIENT, promotion: PROMO, ...properties });
  },

  page(pathname) {
    console.log('SEGMENT: page', Pages[pathname]);
    window.analytics.page(Pages[pathname]);
  }
}



// WEBPACK FOOTER //
// ./src/lib/segment.js